import React, { useState, useEffect } from 'react'
import GenericCustomButton from '../GenericCustomButton';
import IconsPath from '../../assets/icons/index'
import GenericFileShareModal from './GenericFileShareModal';
import ParentModal from '../ParentModal';
import { Slider } from 'antd';
import Icons from '../../assets/icons/index';
import {ChevronLeft, ChevronRight, Download, X, Info, ZoomOut, ZoomIn, Maximize2, Minimize2} from 'lucide-react'
import { motion, AnimatePresence } from "framer-motion";
import GenericInput from '../input/GenericInputComponent';

const GenericMediaViewModal = (props) => {

    const { filesData = [], closeModal = null, current } = props;
    // Files data is going to be an array
    // let filesData = [
    //     {
    //         fileUrl : "",
    //         fileName : "",
    //         fileType : "", // other, image, video , pdf;
    //     }
    // ]

    // State : To store the current file that is selected by the user at inital stage it is going to be 1st index of the file either it is going to be a dummy file.
    const [currentFile, setCurrentFile] = useState(filesData?.[0] || {
        "fileName": "File Name Not Found",
    });

    const [currentFileIndex, setCurrentFileIndex] = useState(current ? current : 0)
    const [selectedModal, setSelectedModal] = useState("");
    const [currentZoom, setCurrentZoom] = useState(100);
    const [isExpandedView, setIsExpandendView] = useState(false)

    useEffect(() => {
        {
            if (filesData?.[currentFileIndex]) {
                setCurrentFile(filesData?.[currentFileIndex])
                setCurrentZoom(100)
            }
        }
    }, [currentFileIndex])

    const getDownloadUrl = (url) => {
        if (url.includes('response-content-disposition=')) {
            return url.replace('response-content-disposition=inline', 'response-content-disposition=attachment');
        } else if (url.includes('?')) {
            return url + '&response-content-disposition=attachment';
        } else {
            return url + '?response-content-disposition=attachment';
        }
    };

    // To handle all the changes of the component
    const handleChange = (type, data) => {
        switch (type) {
            case "expandView": {
                setIsExpandendView((prev)=>!prev)
                break;
            }
            case "downloadData": {
                const downloadUrl = getDownloadUrl(currentFile?.fileUrl);
                window.open(downloadUrl);
                break;
            }
            case "shareData": {
                setSelectedModal("shareDataModal");
                break;
            }
            case "zoomIn": {

                if(currentZoom === 800) return;

                let updatedZoom = currentZoom;
                if(currentZoom%10 !== 0) {
                    updatedZoom = currentZoom + 10 - currentZoom%10;
                } else {
                    updatedZoom = updatedZoom + 10;
                }
                setCurrentZoom(updatedZoom)

                break;
            }
            case "zoomOut": {

                if(currentZoom <= 10) return;

                let updatedZoom = currentZoom;
                if(currentZoom%10 !== 0) {
                    updatedZoom = currentZoom - currentZoom%10;
                } else {
                    updatedZoom = updatedZoom - 10;
                }
                setCurrentZoom(updatedZoom)

                break;
            }
            default:
        }
    }

    const getParentChildProps = () => {
        let payload = {
            closeModal: () => { setSelectedModal("") },
            animationType: "bottom"
        }

        switch (selectedModal) {
            case "shareDataModal": {
                return {
                    ...payload,
                    parentModalOuterMostClassName: 'flex items-center justify-center',
			        postitionProps: { position: 'relative' },
                    dimensions: { width: "auto", height: "auto", borderRadius: 5},
                    fileUrl: currentFile?.fileUrl
                }
            }
            default:
        }
    }

    const getChildComponent = () => {
        switch (selectedModal) {
            case "shareDataModal": return GenericFileShareModal;
            default: {
                return <React.Fragment></React.Fragment>
            }
        }
    }

    const renderMediaControls = () => {
        let Component = null;

        // Render the zoom in and zoom out functinality
        Component = <div className={`media-controls absolute right-[24px] flex items-center gap-3 ${isExpandedView ? 'bottom-[32px]' : 'bottom-[32px] 2xl:bottom-[42px]'}`}>
            {/* {Component} */}
            <GenericInput
                gibInnerClassName='!h-[26px]'
                inputDropdownExtraClass='!text-[11px]'
                genInputExtraClass='zoomInOutDropdown !mb-0 max-w-[70px]'
                type="dropdown"
                placeholder = {"Send As Filter"}
                inputKey="searchItemCode"
                value={`${currentZoom}%`}
                iconRight={<Icons.DownArrowNew />}
                onChange={(val) => {
                    console.log('val1231122241', val)
                    setCurrentZoom(val?.zoomValue)
                }}
                inputProps={() => ({
                    modalMainClass: '!top-auto !bottom-[calc(100%+4px)]',
                    headerKeys: {
                        "value": {}
                    },
                    itemKeys: {
                        "value": [(states, functions, item) => {
                            return (
                                <p className='mb-0 text-fontBlack whitespace-nowrap'>{typeof (item?.value) == "function" ? item?.value() : item?.value}</p>
                            )
                        }]
                    },
                    getListData: () => [
                        {
                            key: 1,
                            value: <span className='text-xs font-medium text-white'>10%</span>,
                            zoomValue: 10
                        },
                        {
                            key: 2,
                            value: <span className='text-xs font-medium text-white'>25%</span>,
                            zoomValue: 25
                        },
                        {
                            key: 3,
                            value: <span className='text-xs font-medium text-white'>50%</span>,
                            zoomValue: 50
                        },
                        {
                            key: 4,
                            value: <span className='text-xs font-medium text-white'>75%</span>,
                            zoomValue: 75
                        },
                        {
                            key: 5,
                            value: <span className='text-xs font-medium text-white'>100%</span>,
                            zoomValue: 100
                        },
                        {
                            key: 6,
                            value: <span className='text-xs font-medium text-white'>200%</span>,
                            zoomValue: 200
                        },
                        {
                            key: 7,
                            value: <span className='text-xs font-medium text-white'>300%</span>,
                            zoomValue: 300
                        },
                        {
                            key: 8,
                            value: <span className='text-xs font-medium text-white'>400%</span>,
                            zoomValue: 400
                        },
                        {
                            key: 9,
                            value: <span className='text-xs font-medium text-white'>500%</span>,
                            zoomValue: 500
                        },
                        {
                            key: 10,
                            value: <span className='text-xs font-medium text-white'>600%</span>,
                            zoomValue: 600
                        },
                        {
                            key: 11,
                            value: <span className='text-xs font-medium text-white'>700%</span>,
                            zoomValue: 700
                        },
                        {
                            key: 12,
                            value: <span className='text-xs font-medium text-white'>800%</span>,
                            zoomValue: 800
                        }
                    ].reverse()
                })}
            />
            <div className='flex items-center gap-1'>
                <GenericCustomButton
                    leftIcon={<ZoomOut size={20} strokeWidth={1.5} color='white' className='shrink-0' />}
                    className='p-[2px] rounded-[3px] hover:bg-[#6E7279]'
                    onClick={()=>handleChange('zoomOut')}
                    disabled={currentZoom === 10}
                />
                <Slider
                    value={currentZoom}
                    onChange={(val) => setCurrentZoom(val)}
                    min={10}
                    max={800}
                    style={{
                        // Customize the color to red or any other color you prefer
                        track: {
                            backgroundColor: 'red',
                        },
                        handle: {
                            borderColor: 'red',
                            backgroundColor: 'red',
                        },
                        width: '80px', // Set the width as needed
                    }}
                />
                <GenericCustomButton
                    leftIcon={<ZoomIn size={20} strokeWidth={1.5} color='white' className='shrink-0' />}
                    className='p-[2px] rounded-[3px] hover:bg-[#6E7279]'
                    onClick={()=>handleChange('zoomIn')}
                    disabled={currentZoom === 800}
                />
            </div>
        </div>

        if (currentFile?.["fileType"] === "video") {
            // Add the video controls here
        }

        return Component;
    }

    const renderHeaderComponent = () => {
        return (
            <div className='givm-head flex items-center justify-between w-full'>
                {/* the header component will contain the name and controls of the media section based on the type of the media content*/}
                {/* Render the file name of the media component */}
                {currentFile?.["fileName"] && (
                    <h3 className='text-[13px] font-semibold text-white m-[0]'>{currentFile?.["fileName"] || "File Name Not Found!"}</h3>
                )}
                <React.Fragment>
                    {/* Render the media controls for the given media content */}
                    {/* {renderMediaControls()} */}
                    <div></div>
                    <div className='givmh-right flex items-center gap-3'>
                        {/* Render the download and share icon to download the data the share the data */}
                        <GenericCustomButton
                            onClick={() => handleChange("expandView")}
                            leftIcon={isExpandedView ? <Minimize2 size={19} color='white' className='shrink-0' /> : <Maximize2 size={19} color='white' className='shrink-0' />}
                            tooltip={isExpandedView ? 'Collapse' : 'Expand'}
                            className='px-[5px] py-[3px] aspect-square w-[30px] h-[30px] shrink-0 rounded flex items-center justify-center bg-[#6E7279] hover:opacity-75'
                        />
                        {
                            (currentFile?.fileType !== 'pdf' && (!props.hideDownloadOption && currentFile?.["fileUrl"])) && <GenericCustomButton
                                onClick={() => handleChange("downloadData")}
                                leftIcon={<Download size={19} color='white' className='shrink-0' />}
                                tooltip='Download'
                                className='px-[5px] py-[3px] aspect-square w-[30px] h-[30px] shrink-0 rounded flex items-center justify-center bg-[#6E7279] hover:opacity-75'
                            />
                        }
                        {
                            (!props.hideShareOption && currentFile?.["fileUrl"]) && <GenericCustomButton
                                onClick={() => handleChange("shareData")}
                                leftIcon={<IconsPath.FileShareIcon2 />}
                                tooltip='Share'
                                className='px-[5px] py-[3px] aspect-square w-[30px] h-[30px] shrink-0 rounded flex items-center justify-center bg-[#6E7279] hover:opacity-75'
                            />
                        }

                        {/* At the end od the header component render the cross iocn to close the component */}
                        {/* Render the close icon */}
                        {/* TODO: Create the hover effect on this close icon */}
                        {closeModal &&
                            <>
                                <GenericCustomButton
                                    onClick={closeModal}
                                    disabled={false}
                                    loading={false}
                                    leftIcon={<div className='flex items-center gap-2'><span className='text-[11px] text-white'>Esc</span> <div className='h-[12px] w-[1px] shrink-0 bg-white'></div></div>}
                                    rightIcon={<X size={19} color='white' className='ml-2' />}
                                    className='ml-1 flex items-center justify-center hover:opacity-75'
                                />
                            </>
                        }
                    </div>
                </React.Fragment>
            </div>
        )
    }

    const renderContentPreview = (file, isCurrentlyOpened) => {
        console.log("File Url", file, file?.fileType);
        
        switch (file?.fileType) {
            case "image": {
                return <div className={`w-full h-full bg-[#FFFFFFCC] duration-200 ${isCurrentlyOpened ? 'scale-100' : 'scale-105 group-hover:scale-100'}`}>
                    {file?.fileUrl ? <img className='w-full h-full object-cover' src={file?.fileUrl} /> : <Icons.ImageThumbnail />}
                </div>
            }
            case "video": {
                return <div className={`w-full h-full bg-[#FFFFFFCC] duration-200 ${isCurrentlyOpened ? 'scale-100' : 'scale-105 group-hover:scale-100'}`}>
                    {/* Please provide the backup image url */}
                    {file?.fileUrl ?
                        <video className='videoPlayer w-full h-full object-cover object-center' width="100%" preload="metadata">
                            <source src={file?.fileUrl} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                        :
                        <Icons.ImageThumbnail />
                    }
                </div>
            }
            case "pdf": {
                return <div className={`PreviewPdfIcon w-full h-full flex items-center justify-center bg-[#FFFFFFCC] duration-200 ${isCurrentlyOpened ? 'scale-100' : 'scale-105 group-hover:scale-100'}`}>
                    <Icons.PdfFileIcon2 width={32} height={32} />
                </div>
            }
            case "xlsx":
            case "xls":
            case "excel": {
                return <div className={`PreviewPdfIcon w-full h-full flex items-center justify-center bg-[#FFFFFFCC] duration-200 ${isCurrentlyOpened ? 'scale-100' : 'scale-105 group-hover:scale-100'}`}>
                    <Icons.ExcelFileIcon2 width={31} height={31} />
                </div>
            }
            case "doc":
            case "docx": {
                return <div className={`PreviewPdfIcon w-full h-full flex items-center justify-center bg-[#FFFFFFCC] duration-200 ${isCurrentlyOpened ? 'scale-100' : 'scale-105 group-hover:scale-100'}`}>
                    <Icons.WordFileIcon2 width={31} height={31} />
                </div>
            }
            default: {
                return <div className={`w-full h-full flex items-center justify-center duration-200 ${isCurrentlyOpened ? 'scale-100' : 'scale-105 group-hover:scale-100'}`}>
                    <Icons.FileIcon width={31} height={31} />
                </div>
            }
        }
    }

    const handlePagination = (type, data) => {
        switch (type) {
            case "prevImg": {
                setCurrentFileIndex(prev => {
                    if (prev == 0) {
                        console.log("current sdfasd",currentFileIndex, filesData);
                        if (filesData?.length > 1) {
                            return filesData?.length - 1
                        }
                    }
                    else {
                       return Number(prev) - 1;
                    }
                })
            }
                break;
            case "nextImg": {
                setCurrentFileIndex(prev => {
                    if ((filesData?.length - 1) == prev) {
                        if (filesData?.length > 1) {
                            return 0;
                        }
                    }
                    else {
                       return Number(prev) + 1;
                    }
                })
            }
                break;
            case "imageClick": {
                setCurrentFileIndex(data)
            }
                break;
        }
    }

    // Function : To render the list of the all the media files present.
    const renderBottomMediaList = () => {

        return <AnimatePresence>
                {!isExpandedView && <div className='givm-footer relative flex items-center w-full'>
                {/* <div  onClick={() => handlePagination("prevImg")} className='w-[75px] flex items-center justify-center absolute left-0 bottom-0 bg-gradient-to-r from-black z-10 to-transparent' style={{cursor:"pointer"}}>
                    <GenericCustomButton
                        leftIcon={<span><ChevronLeft color='white'/></span>}
                        className={'!bg-transparent w-[4%] h-[70px] flex items-center justify-center mr-[5px]'}
                    />
                </div> */}

                        <motion.div 
                            initial={{ y: 0, opacity: 0 }}      // Start slightly above and invisible
                            animate={{ y: 0, opacity: 1 }}      // Animate to normal position and fully visible
                            exit={{ y: 20, opacity: 0 }}        // Move down and fade out on removal
                            transition={{ duration: 0.3 }}      // Adjust speed here
                            className='px-2.5 py-0.5 absolute z-[1] top-[-32px] left-[calc(50%-18px)] rounded-full bg-[#FFFFFF1A]'
                            style={{
                                mixBlendMode: 'difference'
                            }}
                        >
                            <p className='mb-0 text-[13px] font-medium text-white'>{currentFileIndex+1}/{filesData?.length}</p>
                        </motion.div>

                        <motion.div 
                            initial={{ y: 0, opacity: 0 }}      // Start slightly above and invisible
                            animate={{ y: 0, opacity: 1 }}      // Animate to normal position and fully visible
                            exit={{ y: 20, opacity: 0 }}        // Move down and fade out on removal
                            transition={{ duration: 0.3 }}      // Adjust speed here
                            className='givmf-img scrollbar-thin-dark px-1.5 py-1.5 mx-auto max-w-[calc(100%-400px)] xl:max-w-[calc(100%-700px)] flex items-center gap-2.5 overflow-x-auto'
                        >
                            {filesData?.map((file, index) => {
                                return <div
                                        className={`givmfi cursor-pointer shrink-0 w-[60px] h-[60px] rounded-lg group overflow-hidden hover:border-[3px] hover:border-white hover:shadow-[0px_0px_4px_4px_#FFFFFF40] ${index === currentFileIndex ? "border-[3px] border-white shadow-[0px_0px_4px_4px_#FFFFFF40]" : "border border-[#FFFFFF99] shadow-none"}`} 
                                        onClick={() => handlePagination("imageClick", index)} 
                                        key={index?.toString()}
                                        >
                                    {renderContentPreview(file, index === currentFileIndex )}
                                </div>
                            })}
                        </motion.div>
                {/* <div onClick={() => handlePagination("nextImg")}  className='w-[75px] flex items-center justify-center absolute right-0 bottom-0 bg-gradient-to-l from-black z-10 to-transparent pointer' style={{cursor:"pointer"}}>
                    <GenericCustomButton
                        leftIcon={<span><ChevronRight color='white'/></span>}
                        className={'!bg-transparent w-[4%] h-[70px] flex items-center justify-center ml-[5px] mr-[0]'}
                    />
                </div> */}
            </div>}
        </AnimatePresence>

    }

    // Function: TO render the actual content of current selected file
    const renderContent = () => {
        switch (currentFile?.fileType) {
            case "image": {
                return <div className='givmm-data scrollbar-thin-dark w-full h-full overflow-auto flex items-start justify-start'
                                // style={{
                                //     transform: `scale(${currentZoom}%) translateZ(0)`,
                                //     backfaceVisibility: 'hidden',
                                //     willChange: 'transform'
                                // }}
                >
                        <div className='shrink-0 mx-auto' style={{
                            width: currentZoom > 100 ? 'auto' : '100%',
                            height: `${currentZoom}%`,
                        }}>
                                <img className='w-full h-full object-contain' src={currentFile?.fileUrl || require('../../assets/icons/NoImgToView.svg')}
                                    // style={{ transform: `scale(${1 + currentZoom / 100})` }} 
                                    />
                        </div>
                    </div>
            }
            case "video": {
                return <div className='givmm-data w-full h-full overflow-hidden'>
                    {currentFile?.fileUrl ?
                        <video controls className="videoPlayer mx-auto w-auto h-full" preload="metadata">
                            <source src={currentFile?.fileUrl} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                        :
                        <Icons.ImageThumbnail />
                    }
                </div>
            }
            case "pdf": {
                return <div className='h-full w-full'>
                    <iframe src={currentFile?.fileUrl} frameBorder="false" style={{ width: "100%", height: "100%" }}></iframe>
                </div>
            }

            case "xlsx":
            case "xls": 
            case "excel": {
                return <div className='h-full w-full flex flex-col items-center justify-center'>
                    <div className={`PreviewPdfIcon w-full flex items-center justify-center duration-200`}>
                        <Icons.ExcelFileIcon2 width={250} height={300} />
                    </div>
                    <div className='flex items-center gap-2'>
                        <Info size={24} color='#FFB142' className='shrink-0' />
                        <p className='mb-0 text-base font-medium text-white'>Preview Unavailable, Download to view on your device.</p>
                    </div>
                </div>
            }
            case "doc":
            case "docx": {
                return <div className='h-full w-full flex flex-col items-center justify-center'>
                    <div className={`PreviewPdfIcon w-full flex items-center justify-center duration-200`}>
                    <Icons.WordFileIcon2 width={250} height={300} />
                    </div>
                    <div className='flex items-center gap-2'>
                        <Info size={24} color='#FFB142' className='shrink-0' />
                        <p className='mb-0 text-base font-medium text-white'>Preview Unavailable, Download to view on your device.</p>
                    </div>
                </div>
            }

            default: {
                return <div className='h-full w-full flex flex-col items-center justify-center'>
                    <div className={`PreviewPdfIcon w-full flex items-center justify-center duration-200`}>
                    <Icons.FileIcon width={250} height={300} />
                    </div>
                    <div className='flex items-center gap-2'>
                        <Info size={24} color='#FFB142' className='shrink-0' />
                        <p className='mb-0 text-base font-medium text-white'>Preview Unavailable, Download to view on your device.</p>
                    </div>
                </div>
            }
        }
    }

    
    const handleKeyDown = (event) => {
        if (event.key === 'ArrowRight') {
            handlePagination("nextImg")
        } else if (event.key === 'ArrowLeft') {
            handlePagination("prevImg")
        }
    };

    useEffect(() => {

        if(selectedModal || filesData?.length <= 1) return;

        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [selectedModal]);

    return (
        <>
            {isExpandedView && currentFile?.fileType === 'image' && <motion.div
                initial={{opacity: 0}}
                animate={{opacity: 1}}
                exit={{opacity: 0}}
                transition={{duration: .2}}
                className='h-full w-full absolute top-0 left-0 z-[0]'
                style={{
                    backgroundImage: `url(${currentFile?.fileUrl})`, 
                    filter: 'brightness(.4)',
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                 }}
            ></motion.div>}  
            <div className='generic-img-view-modal p-[16px] pb-1 2xl:pb-4 w-full h-full relative z-[2]'>
                    
                {/* Render the header component */}
                {renderHeaderComponent()}

                {/* Body container with smooth expansion */}
                <motion.div
                    initial={false} // prevents initial mount animation
                    animate={{
                        height: isExpandedView ? "calc(100% - 88px)" : "calc(100% - 124px)",
                        paddingTop: isExpandedView ? "4px" : "32px",
                        paddingBottom: isExpandedView ? 0 : "52px",
                        paddingLeft: isExpandedView ? 0 : "62px",
                        paddingRight: isExpandedView ? 0 : "62px",
                        transition: { duration: 0.2, ease: 'easeIn' },
                    }}
                    style={{ transformOrigin: "top" }} 
                    className="givm-mid mt-[8px] mb-1 w-full flex-1 relative flex flex-col overflow-hidden"
                >
                    {/* Left navigation */}
                    <motion.div
                        initial={false}
                        animate={{}}
                        transition={{ duration: 0.3 }}
                        className="absolute z-[1] top-1/2 left-[0] xl:left-[12px] -translate-y-1/2"
                    >
                        <GenericCustomButton
                            leftIcon={<ChevronLeft size={24} color='white'/>}
                            className='p-[4px] h-[40px] w-[40px] flex items-center justify-center rounded-full bg-[#6E7279] hover:opacity-75 focus:ring focus:ring-primaryBtnFocus'
                            onClick={() => handlePagination("prevImg")}
                            disabled={filesData?.length <= 1}
                        />
                    </motion.div>

                    {/* Media content */}
                    <div className='mx-auto relative w-full max-w-[calc(100%-90px)] xl:max-w-[calc(100%-120px)] h-full'>
                        {renderContent()}
                    </div>

                    {/* Right navigation */}
                    <motion.div
                        initial={false}
                        animate={{}}
                        transition={{ duration: 0.3 }}
                        className="absolute z-[1] top-1/2 right-[0] xl:right-[12px] -translate-y-1/2"
                    >
                        <GenericCustomButton
                            leftIcon={<ChevronRight size={24} color='white'/>}
                            className='p-[4px] h-[40px] w-[40px] flex items-center justify-center rounded-full bg-[#6E7279] hover:opacity-75 focus:ring focus:ring-primaryBtnFocus'
                            onClick={() => handlePagination("nextImg")}
                            disabled={filesData?.length <= 1}
                        />
                    </motion.div>
                </motion.div>

                {/* Bottom media scroller */}
                {renderBottomMediaList()}

                {/* Media controls */}
                {currentFile?.fileType === 'image' && renderMediaControls()}

                {/* Optional child modal */}
                {selectedModal && (
                    <ParentModal
                        getParentChildProps={getParentChildProps()}
                        childComponent={getChildComponent()}
                        closeModal={() => setSelectedModal(false)}
                    />
                )}
            </div>
        </>
    )
}

export default GenericMediaViewModal